import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/66_card_back_spider/66_card_back_spider"
 * Contains 1 texture(s)
 */
export class CardsBacks66CardBackSpiderAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/66_card_back_spider/66_card_back_spider';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '66_spider.png'
    ] as const;
}
